import { createFileRoute } from '@tanstack/react-router';
import { AppLayout } from '@/components/layout/app-layout';
import { requireAuthenticatedUser } from '@/lib/auth-guard';

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: ({ location }) => requireAuthenticatedUser(location),
  pendingComponent: () => (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-muted-foreground">Loading...</div>
    </div>
  ),
  component: AppLayout,
});
